document.addEventListener("alpine:init", () => {
  Alpine.data("analyticsController", () => ({
    stats: {
      pages: [],
      referrals: [],
      countries: [],
      device_types: [],
    },
    tab: "Pages",
    state: "idle",
    startDatePicker: null,
    endDatePicker: null,
    baseURL: "",

    setup(baseURL, stats) {
      this.baseURL = new URL(baseURL);
      this.getStats();
      this.startDatePicker = window.setupFlatpickr("startDate", {
        enableTime: false,
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "M J, Y",
        disableMobile: true,
      });
      this.endDatePicker = window.setupFlatpickr("endDate", {
        enableTime: false,
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "M J, Y",
        disableMobile: true,
      });
    },

    getStats() {
      const $dispatch = this.$dispatch;
      this.state = "loading";

      let stats = this.stats;
      let newState = "idle";

      let statsForm = new FormData(document.getElementById("stats-form"));
      fetch("", {
        credentials: "include",
        method: "POST",
        body: statsForm,
      })
        .then(window.status)
        .then(window.json)
        .then(function(data) {
          data.success?.forEach(function(message) {
            $dispatch("notify", { msg: message, type: "success" });
          });
          data.error?.forEach(function(message) {
            $dispatch("notify", { msg: message, type: "error" });
          });
          stats = data;
          newState = "success";
          // this.state = newState
        })
        .catch(function(err) {
          console.log("Fetch Error :-S", err);
          $dispatch("notify", { msg: "Error getting stats", type: "error" });
          newState = "failed";
          // this.state = newState
        })
        .finally(
          function() {
            this.state = newState;
            this.stats = stats;
            this.startDatePicker.setDate(stats.start, true);
            this.endDatePicker.setDate(stats.end, true);
          }.bind(this),
        );
    },

    getPageURL(path) {
      const url = this.baseURL;
      url.pathname = path;

      return url.toString();
    },
  }));
});
